import { useEffect, useRef } from "react";

import { useOpenModal } from "@/components/modal/utils/openModal";

import { useLadyProfileDto } from "./ladyProfile.api.hook";

export const useOpenLadySliderModal = () => {
  const {
    data,
    clientMutations: { toggleMediaFavorite },
  } = useLadyProfileDto();

  const { openModal, removeOne } = useOpenModal({ darkerBackdrop: true });

  type UpdateLadyPropsFn = ReturnType<
    typeof openModal<"LADY_PROFILE_SLIDER_MODAL">
  >;

  const updateSliderPropsFnRef = useRef<UpdateLadyPropsFn | null>(null);

  useEffect(() => {
    const { current: updatePropsFn } = updateSliderPropsFnRef;
    const media = data?.forms.media;

    if (!updatePropsFn || !media) return;

    updatePropsFn({ media });
  }, [data?.forms.media]);

  const openSliderModalAtIndex = (index: number) => () => {
    const update = openModal("LADY_PROFILE_SLIDER_MODAL", {
      onClose: removeOne,
      isOnline: data?.forms.isOnline,
      ladyId: data?.forms.id,
      isCamAvailable: data?.forms.isCamAvailable,
      media: data?.forms.media,
      initialIndex: index,
      alt: `${data?.forms.name} from ${data?.forms.city}`,
      toggleMediaFavorite,
    });

    updateSliderPropsFnRef.current = update;
  };

  return { openSliderModalAtIndex };
};
